export default (tags) => tags.includes('private')
